import { generateColorArray, offWhiteColor } from './ColorGeneration'
import { DivergingColors, SequentialColor, WeightedColor } from './StaticColors'

export enum ColorPreviewType {
  Monochromatic = 'Monochromatic',
  Divergent = 'Divergent',
  Sequential = 'Sequential',
  Qualitative = 'Qualitative'
}

/**
 * Generates default diverging color array
 * @param size how many colors to generate
 * @param colors defaults to Feedback Loop Diverging Colors
 */
export const generateDivergingColors = (size: number, colors = DivergingColors) => {
  // const colors = generateDynamicDivergingColors(size, '#F4F5D0', '#628E8B', '#16273E')
  if (colors.length !== 3) {
    console.error('Diverging color generation requires 3 distinct colors, replacing with default colors')
    colors = DivergingColors
  }
  const colorPalette = generateDynamicDivergingColors(size, ...colors as [string, string, string])
  return colorPalette
}

export const generateDynamicDivergingColors = (size: number, goodColor: string, neutralColor: string, badColor: string) => {
  if (size === 3) return [goodColor, neutralColor, badColor]
  const goodSide = generateColorArray(goodColor, neutralColor, Math.floor(size / 2)).reverse()
  const badSide = generateColorArray(badColor, neutralColor, Math.floor(size / 2))
  if (size % 2 !== 0) {
    goodSide.push(neutralColor)
  }
  const colors = [...goodSide, ...badSide]
  return colors
}

export const SentimentColors = generateDivergingColors(3)

export const generateSequentialColors = (count: number, color = SequentialColor) => generateColorArray(offWhiteColor(color), color, count)

export const generateWeightedColors = (count: number) => generateColorArray(offWhiteColor(WeightedColor), WeightedColor, count)

export const generateColorMap = (categories: string[], colors: string[]): Record<string, string> => {
  return categories.reduce((colorMap, category, index) => ({
    ...colorMap,
    [category]: colors[index % colors.length]
  }), {})
}
